//Callnovo-Livechat inject code
// (function(w, d, s, u) {
//   w.RocketChat = function(c) { w.RocketChat._.push(c) }; w.RocketChat._ = []; w.RocketChat.url = u;
//   var h = d.getElementsByTagName(s)[0], j = d.createElement(s);
//   j.async = true; j.src = 'https://message.callnovo.net/livechat/rocketchat-livechat.min.js?_=201903270000';
//   h.parentNode.insertBefore(j, h);
// })(window, document, 'script', 'https://message.callnovo.net/livechat?departmentName=XGIMI_JP');

//ChatPlus liveChat code
(function(){
  var w=window,d=document;
  var s="https://app.chatplus.jp/cp.js";
  d["__cp_d"]="https://app.chatplus.jp";
  d["__cp_c"]="b7bca85a_1";
  var a=d.createElement("script"), m=d.getElementsByTagName("script")[0];
  a.async=true,a.src=s,m.parentNode.insertBefore(a,m);})();
$(function($) {
  // bind click event to open callnovo chat dialog when dom reay
  $("#support-livechatbtn").click(function () {
    ChatplusScript.openChat();
    // $('#rocketchat-iframe')[0].contentWindow.postMessage("triggerClick", "https://message.callnovo.net");
  });
});

// contact form code
$(function($) {
  var currentOption = null;
  
  $('#support-formbtn, .contact-close').click(function() {
    showContactForm();
  });
  $('#contactForm_wrapper').click(function(e) {
    if(e.target && e.target.id === 'contactForm_wrapper') {
      showContactForm();
    }
  });

  $('#productSelect').dropdown({
    onChange: function(value, text, $choice) {
      if (value) {
        $($('#productSelect').parents('.required')[0]).removeClass('error');
      }
    }
  });

  $('#storeSelect').dropdown({
    onChange: function(value, text, $choice) {
      if (value) {
        $($('#storeSelect').parents('.required')[0]).removeClass('error');
      }
    }
  });

  function closeIssueSelect() {
    var $select = $('#issueSelect');
    var $customSelect = $('.customSelect');
    var settings = $.fn.dropdown.settings;
    if ($select.hasClass('active')) {
      $select.removeClass('active');
      // semantic-ui transition api
      $customSelect.transition({
        animation  : 'slide down out',
        duration   : settings.duration,
        debug      : settings.debug,
        verbose    : settings.verbose,
        queue      : false
      })
    }
  }

  function openIssueSelect() {
    var $select = $('#issueSelect');
    var $customSelect = $('.customSelect');
    var settings = $.fn.dropdown.settings;
    if (!$select.hasClass('active')) {
      $select.addClass('active');
      // semantic-ui transition api
      $('.customSelect').transition({
        animation  : 'slide down in',
        debug      : settings.debug,
        verbose    : settings.verbose,
        duration   : settings.duration,
        queue      : true,
      })
    }
  }

  //open or close issueSelect option
  $('#issueSelect').click(function (e) {
    var $target = $($(e.target).parent());
    if ($target.hasClass('primaryIssueSelect')) return;
    var $select = $('#issueSelect');
    if ($select.hasClass('active')) {
      closeIssueSelect();
    } else {
      openIssueSelect();
    }
  });

  //close issueSelect option
  $('#issueSelect').on('blur.issueSelect', function() {
    closeIssueSelect();
  });

  // select issue
  $('.primaryIssueSelect .issueOption').click(function () {
    var $this = $(this);
    var $siblings = $this.siblings();
    $siblings.removeClass('selected');
    $this.addClass('selected');
    if (currentOption !== $this) {
      var subIssue = $this.data('subissue').split(',');
      var $subIssueSelect = $('.subIssueSelect');
      $subIssueSelect.html('');
      $.each(subIssue, function(index, issue) {
        $subIssueSelect.append('<div class="issueOption">' + issue + '</div>');
      });
      $subIssueSelect.scrollTop(0);
    }
  });

  $('.subIssueSelect').on('click', '.issueOption', function() {
    var $this = $(this);
    var $siblings = $this.siblings();
    $siblings.removeClass('selected');
    $this.addClass('selected');
    var primaryIssue = $('.primaryIssueSelect .issueOption.selected').text();
    $('#issueValue').text(primaryIssue + ' / ' + $this.text()).removeClass('default');
    $($('#issueSelect').parents('.required')[0]).removeClass('error');
  });
  
  //required check
  let errorMessage = $("#errorMessage");
  let requiredInput = $(".required input");
  let requiredTextArea = $(".required textarea");
  requiredInput.change(function() {
    $($(this).parents('.required')[0]).removeClass('error');
  });
  requiredTextArea.change(function() {
    $($(this).parents('.required')[0]).removeClass('error');
  });
  
  let requiredCheck = function(){
    let flag = 1;
    errorMessage.css("visibility","hidden");
    
    for(let i=0; i < requiredInput.length; i++){
      var $parent = $($(requiredInput[i]).parents('.required')[0]);
        $parent.removeClass("error")
        if(requiredInput[i].value === ''){
            flag = -1;
            $parent.addClass("error");
        }
    }

    for(let i=0; i < requiredTextArea.length; i++){
      var $parent = $($(requiredTextArea[i]).parents('.required')[0]);
      $parent.removeClass("error")
      if(requiredTextArea[i].value === ''){
          flag = -1
          $parent.addClass("error")
          
      }
    }

    let contactselect = $(".contactselect");
    for(let i=0; i < contactselect.length; i++){
      var $current = $(contactselect[i]);
      var $parent = $($current.parents('.required')[0]);
      $parent.removeClass("error")
      if($current.hasClass('default')){
          flag = -1;
          $parent.addClass("error");
      }
    }
    
    if(flag === -1){
      errorMessage.css("visibility","visible");
      return false;
    }
    return true;
  }
        
  let emailCheck = function(){
    let reg= /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/g;
    let $email = $("input[name='email']");
    let $emailFiled = $($($email).parents('.required')[0]);
    let customEmail = $email.val();
    if(customEmail.match(reg)){
      $emailFiled.removeClass("error");
      return true
    }else{
      $emailFiled.addClass("error");
      errorMessage.css("visibility","visible");
      return false;
    } 
  }
  
  $("#contactForm").on("submit",function(event){
    event.preventDefault();
    
    if(!requiredCheck()){
        return false;
    }
    
    if(!emailCheck()){
        return false;
    }

    // 5s以内は再度クリックできない仕様
    $(".contactformbtn").addClass("disabled");
    setTimeout(function(){
      $(".contactformbtn").removeClass("disabled");
    },5000)
        
    // contact form api arguments
    var emailValue = $('#emailValue').val();
    var fullnameValue = $('#fullnameValue').val();
    var orderidValue = $('#orderidValue').val();
    var $productValue = $('#productValue');
    var productValue = $productValue.hasClass('default') ? '' : $productValue.text();
    var $productSelectMenu = $('#productSelect .item.active');
    var $storeValue = $('#storeValue');
    var $storeSelectMenu = $('#storeSelect .item.active');
    var storeValue = $storeValue.hasClass('default') ? '' : $storeValue.text();
    var snValue = $('#snValue').val();
    var $issueValue = $('#issueValue');
    var issueValueMenu = $('.primaryIssueSelect .selected');
    var subIssueValueMenu = $('.subIssueSelect .selected');
    var issueValue = $('.primaryIssueSelect .selected').text();
    var subIssueValue = $('.subIssueSelect .selected').text();
    var descriptionValue = $('#descriptionValue').val();
    var args = {
      fullName: fullnameValue,
      email: emailValue,
      orderNumber: orderidValue,
      product: productValue,
      serialNumber: snValue,
      ticketType: issueValue,
      subType: subIssueValue,
      description: descriptionValue,
      platform: storeValue,
      xgimi_token: '53d734bd79a42d16222e073d4cac11dc',
      site: 'JP'
    };
    
    // console.log("客服反馈表单传入参数:",args);

    const formClear = function(){

      // Clear inputbox
      $("#contactForm")[0].reset();

      // Clear selected Value add default text
      $productValue.empty();
      $productValue.addClass('default');
      $productValue.prepend('選択してください');

      $storeValue.empty();
      $storeValue.addClass('default');
      $storeValue.prepend('選択してください');

      $issueValue.empty();
      $issueValue.addClass('default');
      $issueValue.prepend('選択してください');

      // Clear active status
      issueValueMenu.removeClass('selected');
      subIssueValueMenu.removeClass('selected');
      $storeSelectMenu.removeClass('active selected');
      $productSelectMenu.removeClass('active selected');

    }

    axios({
      url: 'https://xgimi-srv-jp.xgimi.com/api/contactform',
      method: 'post',
      data: args
      // transformRequest: [function (data) {
      //   var ret = [];
      //   for (var it in data) {
      //     if (data[it]) {
      //       ret.push(it + '=' + encodeURIComponent(data[it]));
      //     }
      //   }
      //   return ret.join('&');
      // }],
      // headers: {
      //   // 'Content-Type': 'application/x-www-form-urlencoded'
      //   'Content-Type': 'application/json'
      // }
    }).then(function (response) {
      // console.log(response);
      // console.log(response.data.code.body);
      var responseJSON = response.data;

      if(responseJSON.status === 200 && responseJSON.data.code){
      // if (response.status === '200' && response.data && response.data.code === 0) {
        formSubmitSucess();
        formClear();

      } else {
        var errorMsg = 'Cannot connect to our CRM system,please try again';
        if (responseJSON.data && responseJSON.data.msg) {
          errorMsg = responseJSON.data.msg;
        }
        showContactForm();
        alert(errorMsg);
      }
    });
  })
});

const formSubmitSucess = function() {
  $('#contactForm').addClass('hidden');
  $('#successForm').addClass('show');
  setTimeout(function() {
    showContactForm();
    setTimeout(function(params) {
      $('#contactForm').removeClass('hidden');
      $('#successForm').removeClass('show');
    }, 1000);
  },1000);
}

const showContactForm = function () {
  let $wrapper = $('#contactForm_wrapper');
  if (!$wrapper.hasClass('active')) {
    $wrapper.addClass('active');
  } else {
    $wrapper.removeClass('active');
  }
}

// phonecall code
$(function($) {
  $('#support-phonecallbtn, .phone-close').click(function() {
    showPhoneCall();
  });
  
  $('#phoneCall_wrapper').click(function(e) {
    if(e.target && e.target.id === 'phoneCall_wrapper') {
      showPhoneCall();
    }
  });

  
});

const showPhoneCall = function () {
  let $wrapper = $('#phoneCall_wrapper');
  if (!$wrapper.hasClass('active')) {
    $wrapper.addClass('active');
  } else {
    $wrapper.removeClass('active');
  }
}